export const libEnTranslations = {
  home: 'Home',
  login: {
    title: 'Login to Ithinkdt',
    login: 'Login',
  },
  register: 'Register',
  resetPwd: {
    resetPwd: 'Reset password',
  },
  ithinkdt: 'ithinkdt',
  projectName: 'ithinkdt',
  topSearchPh: 'Search for...',
  language: 'Languages',
  personalCenter: 'Personal Center',
  setUp: 'Set Up',
  logOut: 'Logout',
  backPage: 'Back to home page',
  returnPage: 'Return to the previous page',
  loadingData: 'Loading Data...',
  pleaseChoose: 'Please Choose',
  inprocessinQuiry: 'In the process of inquiry',
  noData: 'no data',
  nomatchingResult: 'No matching result',
  pleaseInputContent: 'Please enter the search content',
  generalManagement: 'General Code Classification Management',
  universalManagement: 'Universal Code Value Management',
  normal: 'normal',
  abnormal: 'abnormal',
  dormancy: 'dormancy',

  operations: {
    operation: 'Operation',
    sliding: {
      open: 'Open',
      close: 'Close',
    },
    add: {
      add: 'Add',
      succ: 'Add successfully!',
    },
    edit: {
      edit: 'Edit',
      succ: 'Edit successfully!',
      editSearch: 'Edit search items',
      editHeader: 'Edit Header',
    },
    view: 'View',
    roleSetting: 'Roles configuration',
    ok: 'Ok',
    save: 'Save',
    delete: {
      delete: 'Delete',
      confirm: 'Are you sure you want to delete it?',
      checkEmpty: 'Please select at least one data to delete!',
      succ: 'Delete successfully!',
    },
    fill: {
      mustFill: 'Get involved in environmental protection!',
    },

    next: {
      next: 'Next',
      finish: 'Finish',
    },
    lock: {
      lock: 'Lock',
      confirm: 'Are you sure you want to lock it?',
      succ: 'Lock successfully!',
    },
    publish: {
      publish: 'Publish',
      succ: 'publish successfully!',
    },
    reset: {
      reset: 'Reset',
      confirm: 'Are you sure you want to reset?',
      succ: 'Reset successfully!',
    },
    confirm: {
      confirm: 'Confirm',
    },
    cancel: {
      cancel: 'Cancel',
      confirm: 'Are you sure you want to cancel?',
      succ: 'Cancel successfully!',
    },
    close: {
      close: 'Close',
    },
    select: {
      select: 'Select',
      confirm: 'Please select at least one piece of data!',
    },
    search: 'Search',
    searchControl: 'This search control type is not available for the time being',
    fold: 'fold',
    unfold: 'unfold',
    checkAll: 'checkAll',
    refresh: 'refresh',
  },

  placeholder: {
    input: 'please enter...',
    select: 'please select...',
  },

  list: {
    total: 'Total {{value}} items',
  },

  chName: 'Chinese name',
  enName: 'English name',
  createDate: 'Created date',
  creator: 'Creator',
  type: 'Type',
  remark: 'Remark',
  message: 'Message',
  noControlType: 'No control type is available',
  required: 'Please enter {{value}}',
  yes: 'yes',
  no: 'no',
  password: 'password',
  invitationCode: 'Invitation code',

  week: {
    Sunday: 'Sunday',
    Monday: 'Monday',
    Tuesday: 'Tuesday',
    Wednesday: 'Wednesday',
    Thursday: 'Thursday',
    Friday: 'Friday',
    Saturday: 'Saturday',
  },
  netTips: {
    netError0: 'The network is abnormal, please check and try againï¼',
    netError401: 'Please login first and then visitï¼',
    netError403: 'Insufficient permissions, please contact the administrator and try againï¼',
    netError404: 'The request address is wrong, please confirm and try againï¼',
    netError505: 'The server is out of order, please try again laterï¼',
    netError504: 'The request timed out, please try again laterï¼',
    netWarn: 'Unknown errors, mostly due to the fact that the back end does not support CORS or invalid configuration',
    error: 'Request timed outï¼',
  },

  fileUpload: {
    upload: 'upload',
    fileUpload: 'File Upload',
    confirmUpload: 'Confirm Upload',
    cancel: 'Cancel',
    clickArea: 'Click or drag files to upload to this area',
    supportDocuments: 'Support single or batch file upload, prohibit uploading company data or other related documents',
    uploadSuccess: 'Upload Success!',
    uploadError: 'Upload failed: unknown error',
  },

  pagesTab: {
    myCollection: 'My collection',
    noCollection: 'No collection',
  },
  settingDrawer: {
    systemSetup: 'System Setup',
    styleSettings: 'Page style setting',
    themeColor: 'Theme Color',
    navigationMode: 'Navigation Mode',
    contentAreaWidth: 'Content Width',
    fixedHeader: 'Fixed Header',
    hideWhileSliding: 'Hidden Header when scrolling',
    themeCompiled: 'The theme is being compiled!',
    successfulCompilation: 'Successful compilation!',
    styles: {
      darkStyle: 'Dark menu style',
      brightStyle: 'Bright color menu style',
    },
    colors: {
      blue: 'Blue',
      red: 'Red',
      volcano: 'Volcano',
      croci: 'Croci',
      cyan: 'Cyan',
      green: 'Green',
      geekblue: 'Mazarine',
      purple: 'Purple',
    },
    navModes: {
      slidMenu: 'Side menu layout',
      topMenu: 'Top menu layout',
    },
    contentWidths: {
      streaming: 'Streaming',
      fixedWidth: 'Fixed width',
    },
  },
  route: {
    baseData: {
      codeType: 'Generic code classification management',
      codeValue: 'Common code value management',
    },
    system: {
      userManagement: 'User management',
      authorityManagement: 'Authority management',
      roleManagement: 'Role management',
      departManagement: 'Divisional management',
      systemParam: 'System parameter',
      systemLog: 'System log',
      businessLog: 'Business diary',
      tenant: 'Tenant management',
      app: 'App management',
      resourcePackage: 'Resource package',
    },
  },

  defaultValue: {
    item: 'nape',
  },
  account: {
    exchangeSuccess: 'Switch success',
    settingSuccess: 'Successfully set',
    exchangeTitle: 'Switch Account',
    settingDefault: 'Setting Default',
  },
  bind: {
    bindSucc: 'Bind Success',
    unbindSucc: 'Unbind Success',
    bindTitle: 'Bind Account',
    bind: 'Bind',
    account: 'Account',
    hasBind: 'Bound',
    noBind: 'Unbound',
    hasBindSucc: 'Successfully bound, you can use',
    noBindSucc: 'After binding, you can use the',
    accountLogin: 'Account login',
    unbind: 'Unbind',
    unbindResult: 'Unbinding affects the use of',
    bindResult: 'Scan the QR code',
  },
  default: {
    mobileNo: 'Cell-phone number',
    getVerificationCode: 'Get verification code',
    readAndAgree: 'I have read and agree ',
    notesForSupplier: 'Notes for suppliers',
    name: 'account',
    register: 'Account registration',
    clickToOpration: 'Right click to operate',
    navigator: {
      total: 'Total',
      pieceData: 'pieces data,',
      currentDisplay: 'Current display',
      pieces: 'pieces',
    },
    configurationHeader: 'Configuration header',
    request: {
      error: 'Failed to request permission. Please handle the failure! ',
      notSetting: 'The user has not set the notification permission for this site!',
    },
    message: {
      notice: 'Notice',
      clearNotice: 'Clearance notification',
      emptyNotice: 'You have seen all notifications',
      information: 'News',
      clearInformation: 'Empty messages',
      emptyInformation: 'You have read all the messages',
      dealt: 'backlog',
      clearDealt: 'Empty to do',
      emptyDealt: 'You have completed all the tasks',
    },
    route: {
      error: 'The current path to be closed does not exist. Please check and try again! ',
    },
    operations: {
      open: 'Open',
      close: 'Close',
    },
  },

  dictType: {
    dictType: 'Sorting code numbe',
    parentType: 'Parent classification coding',
    enterDictType: 'Please enter the classification code!',
    dictTypeExist: 'Classification coding already exists!',
    enterChName: 'Please enter Chinese name!',
  },

  userManagement: {
    userName: 'User name',
    userNameTips: 'Please enter the user name!',
    name: 'Full name',
    nameTips: 'Please enter the full name!',
    email: 'Email',
    department: 'Department',
    unlock: 'Enable',
    lock: 'Disable',
    mobile: 'Mobile',
    mobileTips: 'Please enter the cell-phone number!',
    accountTips: 'Please enter the correct account number',
    mobileTypeTips: 'Please enter the correct cell-phone format',
    phone: 'Telephone number',
    passwordTips: 'Please enter a password more than {{value}} in length',
    passwordTip: 'Please enter password ',
    oldPasswordTips: 'Please enter your old password',
    newPasswordTips: 'Please enter your new password',
    passwordTypeTips: 'Please enter the correct password!',
    confirmPassword: 'Password confirmation',
    confirmPasswordTips: 'Please input the password again',
    changePasswordSuccess: 'Password changed successfully',
    passwordDiff: 'The two password are not consistent with each other',
    invitationCodeTips: 'Please enter invitation code!',
    lockWarning: "Sorry, you don't have the permission of locking users",
    unlockWarning: "Sorry, you don't have the permission of unlocking users",
    unlockConfirm: 'Confirm to unlock the user?',
    lockConfirm: 'Confirm to lock the user?',
    selectDepartment: 'Please select the department',
    emailTips: 'Please input your email',
    emailTypeTips: 'Please enter the correct email format',
    phoneTips: 'Please input the telephone number.',
    resetPassword: 'Password reset',
    address: 'Address',
    addressTips: 'Please input the address',
    remark: 'Remarks',
    remarkTips: 'Please input the remarks',
    verificationCodeTips: 'Please enter verification code',
    findTenants: 'Tenant search',
    notBelongToTenant: 'This user do not belong to any Tenant',
    isPlatformUser: 'Platform User',
    platformUserTips: "Don't check when creating user of tenant",
  },

  labelManagement: {
    oldPassword: 'Original password',
    newPassword: 'New password',
  },

  systemLog: {
    startEndDate: 'Start and end date',
    logLevel: 'Log level',
    operater: 'Operator',
    logMessage: 'Message content',
    logTime: 'Log time',
    clientIp: 'Client IP',
  },

  businessLog: {
    moduleName: 'Module',
    operation: 'Operation',
  },

  systemParameter: {
    maxLength: 'Please enter a value not more than {{value}} in length',
    maxValue: 'Please enter a value less than {{value}}',
    reload: 'Reload',
  },
  roleManagement: {
    role: 'Role',
    rightSetting: 'Permission setting',
    roleRights: 'Roles permission',
    roleName: 'Role name',
    roleDesc: 'Role description',
    roleNamePlaceholder: 'Please enter the role name',
    roleDescPlaceholder: 'Please enter the role description',
    configPortal: 'Config portal component',
    choosePortalComponentError: 'Please choose at least one portal component',
  },
  dictCode: {
    dictType: 'Sorting code numbe',
    dictKey: 'Versatility cod',
    enterDictType: 'Please enter the classification code!',
    dictTypeExist: 'Classification coding already exists!',
    enterChName: 'Please enter Chinese name!',
    tenant: 'tenant',
    copy: 'copy',
  },
  department: {
    departmentName: 'Name of a department',
    departmentDesc: 'Department description',
    departmentOrder: 'Listorder',
    departmentType: 'Department of type',
    enterDepartmentName: 'Please enter the departmentName!',
    enterDepartmentDesc: 'Please enter the departmentDesc!',
  },
  authority: {
    moduleKbn: 'Permission types',
    parentId: 'Parent module number',
    asMenu: 'Ie.MenuBar True',
    innerType: 'InnerType',
    moduleId: 'Serial number',
    moduleName: 'ModuleName',
    moduleLevel: 'Grade',
    moduleOrder: 'Order',
    css: 'Css',
    asDashboard: 'Home page icon',
    asShortcut: 'Short cut',
    asAccess: 'In the role',
    dashboardColor: 'Background',
    action: 'Picture URL',
    preActions: 'Permission URL',
    enterName: 'Please enter product name',
    appId: 'App',
  },
  appManagement: {
    appId: 'App id',
    appIdTips: 'Please input app id',
    appName: 'App name',
    appNameTips: 'Please input app name',
    onlineDate: 'On line date',
    onlineDateTips: 'Please input on line date',
    director: 'director',
    directorTips: 'Please input director',
    version: 'version',
    versionTips: 'Please input version',
    versionDate: 'Please input version on line date',
    versionDateTips: 'Please select this version on line date',
    status: 'App status',
    on: 'On',
    off: 'Off',
    turnOnConfirm: 'Turn on',
    turnOffConfirm: 'Turn off',
    app: 'App',
    viewApp: 'View app',
    addApp: 'Add app',
    delApp: 'Delete app',
    viewTenant: 'View tenant',
    chooseDelApp: 'Delete app',
  },
  tenantManagement: {
    tenantName: 'Tenant name',
    contactor: 'Contactor name',
    userMax: 'Limit user number',
    endDate: 'End time',
    status: 'Tenant status',
    tenantNameTips: 'Please enter tenant name',
    contactorTips: 'Please enter contactor name',
    logo: 'Tenant address',
    logoTips: 'Please input tenant address',
    domain: 'Domain',
    domainTips: 'Please input domain',
    companyImg: 'Company image',
    slogan: 'slogan',
    sloganTips: 'Please input slogan',
    contactorEmailRequire: 'Please input contactor email',
    contactorEmailError: 'Incorrect email format',
    contactorphoneTips: 'Please enter contactor phone number',
    contactormobileTips: 'Please enter contactor mobile-phone number',
    contactormobileError: 'The phone number is incorrect',
    userMaxTips: 'Please enter Limit user number',
    userMaxError: 'The maximum number of users can only be a number',
    endDateTips: 'Please enter end time',
    unlockConfirm: 'Enable',
    lockConfirm: 'Disable',
    lock: 'Lock',
    normal: 'Normal',
    adminUser: 'Administrator',
    adminUserTips: 'Please select administrator',
    findResource: 'View resource package',
    delResource: 'Delete Resource package',
    insertResource: 'Add resource package',
    resource: 'Resource package',
    selectResource: 'Please select resource package',
    appSetting: 'Apps configuration',
    addTenantApp: 'Add tenant app',
    selectApp: 'Choose app',
    price: 'Price (ï¿¥)',
    app: 'App',
    priceTips: 'Please enter price',
    priceError: 'Prices can only be Numbers',
    appNoTenant: 'This app no tenant now',
    tenantNoApp: 'This tenant no app now',
    tenantNoResource: 'This tenant no resource now',
  },
  resourceManege: {
    resourceName: 'Resource name',
    resourceNamePlaceHolder: 'Please enter resource name',
    resourceDesc: 'Resource description',
    resourceDescPlaceHolder: 'Please enter resource description',
    lockConfirm: 'Confirm to lock the resource package?',
    unlockConfirm: 'Confirm to unlock the resource package',
    resourcePackRights: 'Resource package permission',
    resourceFeature: 'Select the resource bundle feature',
    notBelongToTenant: 'The package has not being assigned',
    chooseDelResource: 'Delete resource package',
  },
  pcpTheme: {
    company: 'Agilines',
    menus: {
      titles: {
        quickLook: 'Quick look',
        feature: 'Features',
      },
      names: {
        collect: 'Collecting',
        allApps: 'All application',
        launcher: 'Launcher',
        bomMgmt: 'BOM management',
        issueMgmt: 'Issue management',
      },
    },
    userPanel: {
      addFriend: 'Add friend',
      customerService: 'My customer service',
      logout: 'Logout',
    },
  },
  caa: {
    msg: {
      downloadFileFailed: 'Download file failed.',
      downloadFileError: 'Download file error.',
      illegalParameters: 'Illegal parameters.',
      getDocInSessionFailed: 'Failed to get document from current session',
      getDocPropFailed: 'Failed to get document attributes:{{value}}',
      fileNotExists: 'File does not exist:{{value}}',
      uploadFailed: 'Upload failed',
      uploadInternalError: 'Upload failedï¼Internal error',
      renameDocFailed: 'Failed to rename document {{value}}',
      paramError: 'Parameter format error, missing[fileList]',
      updatePropFailed: 'Failed to update part attributes',
      updateExtendedPropFailed: 'Failed to update part extended attributes',
      saveDocFailed: 'Failed to save the document',
      updatePropException: 'Update part attributes exception',
      fileNameCannotBeEmpty: 'File name is empty.',
      openDocFailed: 'Open document [{{value}}] failed.',
      openParentDocFailed: 'Failed to open parent document [{{value}}]',
      openParentRootDocFilaed: 'Failed to get the root product of the parent document',
      instanceDocIsNull: 'The instance document [{{value}}] is empty',
      updateInstanceSaveFailed: 'Failed to update instance to save document',
      openChildDocFailed: 'Failed to open sub document[{{value}}]',
      childDocNotExists: 'Sub document [{{value}}] does not exist',
      addInstanceFailed: 'Failed to add instance',
      addedInstanceIsNull: 'Added instance is empty',
      childDocCannotBeNull: 'Sub document cannot be empty',
      removeInstanceFailed: 'Failed to remove instance',
      updateInstanceFailed: 'Failed to update instance',
      missingPartIdParam: 'Missing partâsID parameter',
      openOriginDocFailed: 'Failed to open the original document',
      originDocNotExists: 'The original document does not exist',
      settingPartNoRevisonFailed: 'Failed to set part number and reversion',
      createNewDocFailed: 'Failed to create new document',
      openNewDocFailed: 'Failed to open new document',
      settingNewDocExtendedPropFailed: 'Failed to set new document extension attributes',
      saveNewDocExtendedPropFailed: 'Failed to save new document extended attributes',
      createNewProductFailed: 'Failed to create a product',
      cannotAddYourselfAsChild: 'Cannot add yourself as an instance',
      selectedDocIsEmpty: 'Selected document is empty',
      replaceProductFailed: 'Replace product [{{value}}] failed',
      anErrorOccurred: 'An error occurred. Please try again. Message:{{value}}',
      commandNotFound: 'Command not found',
      aCircularReferenceFound: 'There is a circular reference in the added assembly {{value}}',
      diskFreeSpaceOut: 'There is not enough free disk space at present,Less than {{value}} MB',
      bomConvertFailed: 'Parameter error, cannot be converted to BOM',
      newDocumentFailed: 'Create New Document Failed',
      assembleProductFailed: 'Assemble product failed',
      addExternalComponentFailed: 'Add external component [{{value}}] failed',
      canNotContainChinese: 'The file name [{{value}}] cannot contain Chinese',
      closeDocumentFailed: 'Close document [{{value}}] failed',
      saveDocumentFailed: 'Save document [{{value}}] failed',
      getInstPrdPropFailed: 'Get Instance Product Properties Failed, Instance Name:{{value}}',
      getInstDocFailed: 'Get Instance from document failed, Instance Name:{{value}}',
      unSupportedFileType: 'Unsupported document type : {{value}}',
      compareBomFailed: 'Compare Bom failed',
      shapeCodecanNotContainChinese: 'The Shape Code :{{value}} cannot contain Chinese',
      loginWasExpired: 'Login was expired or token has missing',
      getProductBomUnloadErr: 'The files in the following list could not be found or contain the wrong information for the active document.{{value}}',
      getFileJsonUrlNotFound: 'The getfilejsonurl parameter is not configured',
      foundComponentErr: 'It is found that the files in the following list use component, please use "PCP" - > "check" to convert \n{{value}}',
      dynAssmblyFailed: 'Error in dynamic assembly, please try again',
      downloadFileEmpty: 'The content of the downloaded file {{value}} is empty. Please confirm whether your initiator configuration is correct.',
      windowSwitching: 'The current active window has been switched. Please switch to the window of the following document.{{value}}'
    },
  },
};
